/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';

const TransferConfirmButton = function ({ translations }) {
  return (
    <div className="embeddedServiceSidebarForm">
      <button
        aria-live="off"
        type="submit"
        className="startButton uiButton--default uiButton embeddedServiceSidebarButton"
      >
        <div className="label bBody">{translations.confirmTransfer}</div>
      </button>
    </div>
  );
};

export default TransferConfirmButton;
